
export class QueryUtility {

    getParameterByName(param: string): any {
        var query = this.urldecode(window.location.pathname);
        var vars = query.split('/');
        if (vars.indexOf(param) > 0)
            return vars[2];
        return null;
    }

    urldecode(url: string): any {
        return decodeURIComponent(url.replace(/\+/g, ' '));
    }
}